import { PaymentTypeCode } from '../models/Order';

function displayPaymentType(code: PaymentTypeCode) {
  switch (code) {
  case 'Credit_CreditCard':
    return '信用卡付款';
  case 'CVS_CVS':
  case 'CVS_OK':
  case 'CVS_FAMILY':
  case 'CVS_HILIFE':
  case 'CVS_IBON':
    return '超商代碼付款';
  case 'BARCODE_BARCODE':
    return '超商條碼付款';
  default:
    return code;
  }
}

export default displayPaymentType;
